import React, { useState, useEffect } from 'react'
import { withAuth } from '../../auth'
import Proptypes from 'prop-types'
import AcceptTermsWall from './AcceptTermsWall'
import Logout from './../Logout'

const AuthWall = props => {
  const [userInfo, setInfo] = useState({})
  const { auth } = props

  useEffect(() => {
    if (!auth.loggedIn && !auth.isLoading) {
      auth.login()
    } else if (auth.token.length > 0) {
      const getInfo = async () => {
        const userInfo = await auth.getUserInfo()
        setInfo(userInfo)
      }
      getInfo()
    }
  }, [auth])

  if (auth.isLoading) {
    return <div>Loading...</div>
  } else if (auth.loggedIn) {
    return <AcceptTermsWall userInfo={userInfo} />
  } else {
    return (
      <div>
        Unauthorized! <Logout />
      </div>
    )
  }
}

AuthWall.propTypes = {
  auth: Proptypes.object,
}

export default withAuth(AuthWall)
